import styled from "styled-components";

export const StyledIcon = styled.span`
  margin: 5px 10px 0px 0px;
  top: 3px;
  position: relative;
`;

export const StyledNoFields = styled.p`
  margin: 0 0 9px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #b2b2b3;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
`;
